// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2ZMeK","LocationIcon":"Input_LocationIcon__2KpSU","numberButton":"Input_numberButton__3yRNt","option":"Input_option__2_LtB"};